// import react from 'react';

function Activities(){

    return(<>
    <h1>Hello Activities!</h1>
    </>);
};
export default Activities;